// extracted by mini-css-extract-plugin
export var sliderRange = "_ob-2";
export var sliderRoot = "_ob-0";
export var sliderThumb = "_ob-3";
export var sliderTrack = "_ob-1";